/* eslint-disable @typescript-eslint/no-explicit-any */
import { BASE_API, CONTENT_TYPE, ENTITY_TYPES } from '../utils/constants'
import { getAccessToken } from '../utils/getAlefuser'
import { getSelectedOrganization } from '../utils/selectedOrganization'

export type Filters = {
  userId?: string
} & Pick<getLogsParams, 'entityType'>

export type getLogsResponse = {
  totalRows: number
  auditLogs: AuditLogObject[]
  metadata: {
    name: string
  }
  request: {
    sortDirection: 'Desc'
  } & getLogsParams &
    Filters
} & Pick<getLogsParams, 'entityId' | 'entityType'>

export type getLogsParams = {
  entityId: string
  entityType: ENTITY_TYPES | CONTENT_TYPE
} & PageOptions

const getLogsForType = async (params: getLogsParams & Filters): Promise<getLogsResponse> => {
  try {
    const URI = `${BASE_API}/audit/logs`
    const req = await fetch(URI, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json',
        'X-Tenantid': getSelectedOrganization()
      },
      body: JSON.stringify({
        ...params,
        entityType: params.entityType,
        sortDirection: 'Desc'
      })
    })
    if (req.status !== 200) {
      throw new Error('request Error')
    }
    const data: getLogsResponse = await req.json()
    return data
  } catch (e) {
    console.error(e)
    return {
      totalRows: 0,
      auditLogs: [],
      metadata: {
        name: ''
      },
      request: {
        sortDirection: 'Desc',
        ...params
      },
      entityId: params.entityId,
      entityType: params.entityType
    }
  }
}

export default getLogsForType
